import * as SwitchPrimitive from '@radix-ui/react-switch'

export function Toggle({
  checked,
  onChange,
  label,
  note,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  note?: string
}) {
  return (
    <label className="flex min-h-tap w-full cursor-pointer items-center gap-3">
      <span className="min-w-0 flex-1">
        <span className="block text-body">{label}</span>
        {note ? <span className="mt-[2px] block text-hint text-text-muted">{note}</span> : null}
      </span>
      <SwitchPrimitive.Root
        checked={checked}
        onCheckedChange={onChange}
        className={`relative h-switch-h w-switch-w flex-none rounded-capsule p-[3px] transition-colors duration-row ${
          checked ? 'bg-accent' : 'bg-field shadow-hairline'
        }`}
      >
        <SwitchPrimitive.Thumb className="block h-switch-knob w-switch-knob rounded-full bg-on-accent shadow-card transition-transform duration-row ease-mark data-[state=checked]:translate-x-switch-travel" />
      </SwitchPrimitive.Root>
    </label>
  )
}
